import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users/content-manager/new',
  title: 'Cadastrar Gestor de Conteúdos',
  endpoint: '/app/person',
}
